/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getRegistrationPage = (): Layout => ({
	name: 'AuthStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'RegisterBanner', id: 'register-banner' }],
		second: [{ name: 'Register', id: 'register' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
